import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { TokenService } from './token.service';
import { VersionService } from 'projects/core/src/lib/services/version.service';
import { environment } from 'projects/environments/environment';

@Injectable()

export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private token: TokenService,
    private versionService: VersionService
  ) { }

  public intercept(req: HttpRequest<any>, next: HttpHandler): any {
      req = req.clone({
          setHeaders: {
              Authorization: 'Bearer ' + this.token.getToken(),
              'Client-App-Version': environment.version || null
          }
      });
      
      return next.handle(req).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            this.versionService.checkResponseForVersionMismatch(event);
          }
        })
      );
  }

}
